var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-modal-loading"},[_c('i',{staticClass:"normal-modal-loading__toast"}),_c('p',{staticClass:"normal-modal-loading__content"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }